import { render, staticRenderFns } from "./perception.vue?vue&type=template&id=b48a7682&scoped=true"
import script from "./perception.vue?vue&type=script&lang=js"
export * from "./perception.vue?vue&type=script&lang=js"
import style0 from "./perception.vue?vue&type=style&index=0&id=b48a7682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48a7682",
  null
  
)

export default component.exports